import { CreatePatientThroughMailModal } from './CreatePatientThroughMailModal.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(CreatePatientThroughMailModal)
export { withUnmountHoc as CreatePatientThroughMailModal }
